import { FC } from 'react';
import { BonusEarnDetailsProps } from './types';

import './BonusEarnDetails.scss';
import { Skeleton } from 'antd';

const BonusEarnDetails: FC<BonusEarnDetailsProps> = ({ loading, icon, title, value, bgIcon, bgIconPosition = {} }) => {
    return (
        <>
            <div className="bonus-earn-details">
                {loading ? (
                    <Skeleton.Node
                        active
                        style={{ height: ' 88px', width: '100%', borderRadius: '10px' }}
                    />
                ) : (
                    <>
                        <div className="bonus-earn-details__value">
                            <img
                                src={icon}
                                alt=""
                            />
                            <h2>{value}</h2>
                        </div>
                        <div className="bonus-earn-details__title">
                            <h3>{title}</h3>
                        </div>
                        {bgIcon && (
                            <img
                                style={{ ...bgIconPosition }}
                                src={bgIcon}
                                alt=""
                                className="bonus-earn-details__bg-icon"
                            />
                        )}
                        <div className="bonus-earn-details__bg"></div>
                    </>
                )}
            </div>
        </>
    );
};

export default BonusEarnDetails;
